export default __webpack_public_path__ + "static/logo-main-black-43f61b703270d7a77a611cba784c0092.png";